import React, {useEffect} from 'react';
import {markComponentAsHydrated} from './HydrationProvider';

export const MarkHydrationDone: React.FC<{
  componentId: string;
}> = ({componentId}) => {
  useEffect(() => {
    markComponentAsHydrated(componentId);
  }, [componentId]);

  return null;
};
